import { useMonarchRule } from "../MonarchRulesProvider";
import {
  AbandonedCartIntentMatchTestData,
  UseAbandonedCartIntentMatch,
} from "./types";

const CUSTOM_RULE_ID = "abandonedCartIntentMatch";
const DEFAULT_CTA_TEXT = "Add to cart";

const defaultData: AbandonedCartIntentMatchTestData = {
  enabled: false,
  cartCtaText: DEFAULT_CTA_TEXT,
  bannerCtaText: DEFAULT_CTA_TEXT,
  bannerHeaderText: "Still interested in {category}?",
  bannerSubheaderText: "Enroll in {productTitle} today!",
  productCardCtaText: DEFAULT_CTA_TEXT,
};

const useAbandonedCartIntentMatch: UseAbandonedCartIntentMatch = () => {
  const { isLoading, value } = useMonarchRule<{
    data: AbandonedCartIntentMatchTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading || !value) {
    return {
      isLoading,
      variant: "control",
      data: defaultData,
    };
  }

  const { data } = value;
  const variant = data?.enabled ? "test" : "control";

  return {
    isLoading,
    variant,
    data: {
      enabled: data?.enabled ?? defaultData.enabled,
      cartCtaText: data?.cartCtaText ?? defaultData.cartCtaText,
      bannerCtaText: data?.bannerCtaText ?? defaultData.bannerCtaText,
      bannerHeaderText: data?.bannerHeaderText ?? defaultData.bannerHeaderText,
      bannerSubheaderText:
        data?.bannerSubheaderText ?? defaultData.bannerSubheaderText,
      productCardCtaText:
        data?.productCardCtaText ?? defaultData.productCardCtaText,
    },
  };
};

export default useAbandonedCartIntentMatch;
